import React from 'react';

import Passion from '../components/life/Passion'

import experience from '../data/life-experience'

class Life extends React.Component {

    render(){
        return (
            <div>
                <h2>My life</h2>
                <p>Here are some of the things i like to do</p>

                {experience.map((data)=>
                    <Passion data={data}/>)}
            </div>
        )
    }
}

export default Life;